import React, { useState } from 'react';
import NamedBox from '../atoms/NamedBox';
import ListItem from '../atoms/ListItem';
import ClassIcon from '../icons/ClassIcon';
import SchoolIcon from '../icons/SchoolIcon';
import OffersIcon from '../icons/OffersIcon';
import TFPillLogoColorIcon from '../icons/TFPillLogoColorIcon';
import RugbyIcon from '../icons/RugbyIcon';
import StateIllinoisIcon from '../icons/StateIllinoisIcon';
import PositionRankIcon from '../icons/PositionRankIcon';
import Links from '../molecules/Links';
import { COLOR_BLUE, COLOR_MIDDLE_GRAY } from '../styles/colors';
import {
    Box,
    makeStyles,
    Typography,
  } from '@material-ui/core';
import ProgressLine from '../atoms/ProgressLine';
import HandshakeIcon from '../icons/HandshakeIcon';
import StarIcon from '../icons/StarIcon';
import Stars from '../atoms/Stars';
import NotAvailable from '../atoms/NotAvailable';

const useStyles = makeStyles(theme => ({
    listItem: {
      padding: theme.spacing(.5, 2.5),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.2,
  
      '& a': {
        color: COLOR_BLUE
      }
    },
    dividedContent: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.spacing(.5, 2),
    },
    dividedContentSection: {
      display: 'flex',
      alignItems: 'center',
      minHeight: '30px',
      paddingRight: theme.spacing(2),
      borderRight: `1px solid ${COLOR_MIDDLE_GRAY}`,
  
      '&:last-child': {
        paddingRight: 0,
        borderRight: 0,
      },
    },
    progressLine: {
      padding: 0,
    },
    recruitingLinks: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '200px',
      padding: theme.spacing(1),
    },
    recruitingLink: {
    },
    rankingWrap: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      maxWidth: '230px',
      gap: theme.spacing(2),
      padding: theme.spacing(2, 0),
    },
    rankingContent: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: 'auto',
      fontWeight: 700,
    },
    rankingIcon: {
      maxWidth: '28px',

      '& img': {
        display: 'block',
        maxWidth: '100%',
      }
    },
  }), { name: RecruitingContent.name });
export default function RecruitingContent(props: any) {
    const classes = useStyles();

    const primarySchool = props?.primarySchool
    const player = props?.player;
    const links = props?.links;
    const committedToTeam = props?.committedToTeam;
    return (
      <>
      <NamedBox name='Recruiting'>
        <ListItem
          icon={ClassIcon}
          title='High School Class:'
          className={classes.listItem}
        >
          <div><b>{(primarySchool && primarySchool.graduatingClass) || 0}</b></div>
        </ListItem>

        <ListItem
          icon={SchoolIcon}
          title='School:'
          className={classes.listItem}
        >
          <div className={classes.dividedContent}>
            <div className={classes.dividedContentSection}>
              <span><strong>{(primarySchool?.name || <NotAvailable />)}</strong></span>
            </div>

            <div className={classes.dividedContentSection}>
              <span>GPA: <strong>{player?.gpa || <NotAvailable />}</strong> </span>
            </div>

            <div className={classes.dividedContentSection}>
              <span>SAT: <strong>{player?.sat || <NotAvailable />}</strong></span>
            </div>

            <div className={classes.dividedContentSection}>
              <span>ACT: <strong>{player?.act || <NotAvailable />}</strong></span>
            </div>
          </div>
        </ListItem>

        <ListItem
          icon={OffersIcon}
          title='Offers:'
          className={classes.listItem}
        >
          <div>
            <b>{(player?.offers?.length || 0).toString()}</b>
          </div>
        </ListItem>

        {/* <ListItem
          icon={TFPillLogoColorIcon}
          title='Offer Quality Score:'
          className={classes.listItem}
        >
          <ProgressLine className={classes.progressLine} value={92} />
        </ListItem> */}

        <ListItem
          icon={HandshakeIcon}
          title='Committed:'
          className={classes.listItem}
        >
          <div>
            <b>{committedToTeam ? committedToTeam.name : 'Uncommitted'}</b>
          </div>
        </ListItem>

        <ListItem
          icon={StarIcon}
          title='Star Rating:'
          className={classes.listItem}
        >
          <div>
            <Stars value={player?._247Star ?? player?.compStar ?? 0} />
          </div>
        </ListItem>

        <ListItem
          icon={RugbyIcon}
          title='Industry Rating:'
          className={classes.listItem}
        >
          <div>
            <b>{player?._247Comp}</b>
          </div>
        </ListItem>

        <ListItem
          icon={StateIllinoisIcon}
          title='State Rank:'
          className={classes.listItem}
        >
          <div>
            {
              player?.industryStateRank ? 
                <b>#{player?.industryStateRank} in Illinois</b>
              : <NotAvailable />
            }
          </div>
        </ListItem>

        <ListItem
          icon={PositionRankIcon}
          title={'Pos Rank:'}
          className={classes.listItem}
        >
          <div>
            {
              player?.industryPositionRank ? 
                <b>QB: {player?.industryPositionRank} Nationally</b>
              : <NotAvailable />
            }
          </div>
        </ListItem>

        <ListItem
          title={<img src='/svgs/prep-redzone-logo.svg' alt='Prep Redzone'/>}
          className={classes.listItem}
        >
          <div className={classes.rankingWrap}>
            <div className={classes.rankingContent}>
              <div>State Rank: {player?.prepRedzoneStateRank || <NotAvailable />}</div>
              <div>Position Rank: {player?.prepRedzoneStatePosRank || <NotAvailable />}</div>
            </div>
            
            {
              (player?.prepRedzoneRiser == 1) ?
            <div className={classes.rankingIcon}>
              <img
                src='/images/rankings-riser-logo.png'
                alt='Rankings Riser'
              />
            </div>
              : ''
            }
          </div>
        </ListItem>
        
        {(!!links?.length) && (
          <Links
            className={classes.recruitingLinks}
            linkClassName={classes.recruitingLink}
            links={links}
          />
        )}
      </NamedBox>
      </>
    )
  }